import { Show } from "solid-js"
import { twMerge } from "tailwind-merge"

export const Breadcrumb = (props) => {
  const handleBreadcrumbClick = () => {
    window.posthog?.capture('breadcrumb_clicks', {
      experiment_flags: window.experimentFlags
    })
  }
  
  return (
    <div class={twMerge(
      "flex items-center gap-0.5 text-2xs sm:text-xs my-0.5",
      props.class ?? ''
    )}>
      <For each={props.breadcrumbs}>{(breadcrumb, index) => (
        <>
          <Show
            when={breadcrumb.href}
            fallback={(
              <span class=" rounded-lg  font-bold text-nowrap max-w-full overflow-hidden text-ellipsis">{breadcrumb.label}</span>
            )}
          >
            <a href={breadcrumb.href} onclick={handleBreadcrumbClick} class=" rounded-lg  text-nowrap hover:bg-canvas-depressed font-medium">{breadcrumb.label}</a>
          </Show>
          <Show when={index() != props.breadcrumbs.length - 1}>
            <span>
              <svg width="12" height="12" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* <path d="M8 0L24 16L8 32V0Z" class="fill-current" /> */}
                
<path d="M10.4042 4.80838L21.5958 16L10.4042 27.1916V4.80838Z" fill="currentColor"/>


              </svg>
            </span>
          </Show>
        </>
      )}</For>
    </div>
  )
}